import React from 'react'

import { SERVICE_DEFAULTS } from '~/app/constants'

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'service' implicitly has an 'any' type.
export default function getServiceIcon(service, size) {
  const serviceDefaults =
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    SERVICE_DEFAULTS[service] || SERVICE_DEFAULTS.instagram
  const Component = serviceDefaults.icon || null

  return Component ? <Component size={size} /> : null
}
